module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("Resumer")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("你好，" + _vm._s(_vm.user, _vm.username))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("登出")])]) : _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signUpDialogVisible = true
      }
    }
  }, [_vm._v(" 注册")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.signInDialogVisible = true
      }
    }
  }, [_vm._v("登入")])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("预览")])])]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.signUpDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signUpDialogVisible = false
      }
    }
  }, [_c('SignUpForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "登入",
      "visible": _vm.signInDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signInDialogVisible = false
      }
    }
  }, [_c('SignInForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ce6198"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 79
// module chunks = 1